/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Audit_TitleInputs */

const en_fw_audit_title = /** @type {(inputs: Fw_Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log`)
};

const id_fw_audit_title = /** @type {(inputs: Fw_Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log`)
};

/**
* | output |
* | --- |
* | "Audit log" |
*
* @param {Fw_Audit_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_audit_title = /** @type {((inputs?: Fw_Audit_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Audit_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_audit_title(inputs)
	return en_fw_audit_title(inputs)
});